import { Action } from './Action';
import { Condition } from './Condition';
import { TriggerEnum } from './Trigger';

export interface StepCard {
  id: number;
  index: number;
  order: number;
  step: string;
  iconStep: string;
  title: string;
  variant: VariantStep;
  isVisible?: boolean;
  isRequired?: boolean;
  isEnforcedOrder?: boolean;
  isPrompt?: boolean;
  isForm?: boolean;
  trigger?: TriggerEnum;
  actions: Action[];
  conditionals: Condition[];
  blockers: Condition[];
  node: StepCardNode;
}

export interface StepCardNode {
  id: string;
  outputId: string;
  inputId: string;
  xPositionOffset: number;
  yPositionOffset: number;
  cardHeight: number;
}

export enum VariantStep {
  DEFAULT = 'default',
  OPTIONAL = 'optional',
  CONDITIONAL = 'conditional',
  BLOCKED = 'blocked',
  ENFORCED = 'enforced',
  UNENFORCED = 'unenforced',
}

export type VariantStepType =
  | 'default'
  | 'optional'
  | 'conditional'
  | 'blocked'
  | 'enforced'
  | 'unenforced';

export interface StepConnection {
  id: string;
  from: string;
  to: string;
  insertOrder?: number;
  conditional: boolean;
}
